import { useMobile } from "../hooks/useMobile";

interface RoleCardProps {
  id: string;
  title: string;
  description: string;
  icon: string;
  isSelected: boolean;
  onSelect: (id: string) => void;
}


export const RoleCard = ({ id, icon, title, description, isSelected, onSelect }: RoleCardProps) => {
  const isMobile = useMobile();

  return (
    <div 
      onClick={() => onSelect(id)}
      style={{
        width: isMobile ? '100%' : '32%',
        padding: '20px 25px',
      borderRadius: '10px',
      border: isSelected ? '2px solid #1A2238' : '1px solid #E6E8EC',
      backgroundColor: isSelected ? '#F8FAFC' : 'white',
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'all 0.2s ease',
      marginBottom: isMobile ? '16px' : '0px'
    }}
  >
    <img src={icon} alt="icons" style={{ marginBottom: '12px', width: '60px', height: 'auto' }} />
    <h1 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', fontFamily: 'Manrope", sans-serif', color: '#1F2933' }}>{title}</h1>
    <p style={{ fontSize: '13px', color: '#4B5563', fontWeight: '400' }}>{description}</p>
  </div>
)};